
export default {
	data() {
		return {
			integrations: {}
		};
	},
	computed: {
		onVendorSummaryPage() {
			return this.$route.path === '/vendors';
		},
		actions() {
			return 	[
				{
					id: 1,
					disabled: false,
					iconClass: 'icon icon-document',
					label: 'Details',
					title: 'Select to go to Details',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					disabled: false,
					iconClass: 'icon icon-company',
					label: 'CCL',
					title: 'Select to go to Company Client Location',
					type: 'route-link',
					visible: true
				},
				{
					id: 3,
					disabled: false,
					iconClass: 'icon icon-customer-integration',
					label: 'APIs',
					title: 'Select to go to APIs',
					type: 'route-link',
					visible: true
				},
				{
					id: 4,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: '',
					title: 'select to see the more actions',
					type: 'dropdown',
					visible: true,
					items: [
						{
							id: 5,
							action: {
								path: `/vendors/${
									this.$route.params.integratorId
								}/integrations/history/${
									this.$route.params.integrationId
								}}`
							},
							disabled: false,
							iconClass: 'icon icon-history',
							label: 'History',
							title: 'Select to go to History',
							type: 'route-link',
							visible: true
						}
					]
				}
			]
		}
	}
};
